export default function FormHeader({ title, description }) {
  return (
    <header>
      <h1 className="auth__title">{title}</h1>
      <p className="auth__description">{description}</p>
    </header>
  );
}
